let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1748d")).then(() => parcelRequire('9iT7G'));